'use client';

import { c as _c } from "react/compiler-runtime";
import { AwardIcon } from 'lucide-react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { LazyImage, LoadingIndicator, NoImagePlaceholder } from '@/components/partials';
import { CertificateType } from '@/types/certificate';
import { getResizedPictureUrl, getLocalizedValue } from '@/lib/utils';
type PropsType = {
  certificates: CertificateType[];
  locale: string;
  className?: string;
};
const CertificatesGallery = t0 => {
  const $ = _c(11);
  const {
    certificates,
    locale,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <LoadingIndicator />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== certificates || $[2] !== locale) {
    let t4;
    if ($[4] !== locale) {
      t4 = certificate => {
        if (!certificate.picture) {
          return null;
        }
        const title = getLocalizedValue(certificate, "title", locale);
        return <PhotoView key={certificate.id} src={getResizedPictureUrl(certificate.picture?.path, 1920, 1080)}><div className="group bg-muted relative aspect-4/3 cursor-pointer overflow-hidden rounded-lg border transition-all hover:shadow-lg">{certificate.picture ? <LazyImage src={getResizedPictureUrl(certificate.picture.path, 600, 450)} alt={title} fill={true} sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 33vw" className="object-cover transition-transform duration-300 group-hover:scale-110" /> : <NoImagePlaceholder icon={AwardIcon} />}{title && <div className="absolute inset-x-0 bottom-0 bg-linear-to-t from-black/80 to-transparent p-4"><p className="text-sm font-medium text-white">{title}</p></div>}</div></PhotoView>;
      };
      $[4] = locale;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    t3 = certificates.map(t4);
    $[1] = certificates;
    $[2] = locale;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">{t3}</div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className || $[9] !== t4) {
    t5 = <PhotoProvider maskOpacity={0.9} bannerVisible={true} loadingElement={t2} className={className}>{t4}</PhotoProvider>;
    $[8] = className;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default CertificatesGallery;